module.exports = __webpack_public_path__ + "img/company-insights.a02b09ac.svg";